// removed by extract-text-webpack-plugin
module.exports = {"racer":"_2-Vch6NBTod5teZpnC5LzA","simpleRacer":"_1-8y5dIPyxpunnXS6nyQz4","complexRacer":"p4bCK0Eurff9GWbFxyev","selected":"pYsQqb7L7W9uNkvASyqL_","simpleRacerBottomLine":"_3n4o0VLKVP4HIhyVfOpAva","oddsText":"_2A_PyVpIDgUpgU4AXloraS","racerNumber":"_1yk8FwHxy8Ynpy5j_UEqgA","racerName":"_1G6wStfkuIgsaTw54I-Abt","complexRacerName":"_2SwteGlNvZokB9bmiOpZYa","complexRacerNameText":"_2YgxGdxpFRGCkTfVWoS1Om","racerIcon":"_1qVb0iHVv3ztmQ7PMEVwOH","racerIconImage":"_1jTXtdYatkjHeLQ6UUsnsP","complexRacerIconImage":"aZnJznCMVKMWpmyK-KeM1"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/modules/racing/css/racer.css
// module id = 991
// module chunks = 0